<script setup lang="ts">
import BaseButton from '@/components/ui/BaseButton.vue';

interface Props {
  month: string;           // "yyyy-MM" — displayed in the label
  loading?: boolean;
  hasExisting?: boolean;   // true → "Regenerate"; false → "Generate"
}

interface Emits {
  (e: 'generate'): void;
}

withDefaults(defineProps<Props>(), {
  loading: false,
  hasExisting: false,
});
const emit = defineEmits<Emits>();

function formatMonth(month: string): string {
  const [year, mm] = month.split('-');
  const date = new Date(Number(year), Number(mm) - 1, 1);
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}
</script>

<template>
  <BaseButton
    variant="primary"
    size="md"
    :loading="loading"
    :aria-label="hasExisting
      ? `Regenerate ${formatMonth(month)} report`
      : `Generate ${formatMonth(month)} report`"
    data-testid="generate-report-btn"
    @click="emit('generate')"
  >
    <template v-if="loading">
      <!-- Spinner inline -->
      <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
      </svg>
      Generating…
    </template>
    <template v-else>
      {{ hasExisting ? 'Regenerate Report' : 'Generate Report' }}
      <span class="text-sm opacity-75">· {{ formatMonth(month) }}</span>
    </template>
  </BaseButton>
</template>
